import i18n from 'i18next';

export const INTERVAL_OPTIONS = [
  {
    get label() {
      return i18n.t('queue:statistic tab.form.other settings.interval.interval options.30m');
    },
    value: '30m',
  },
  {
    get label() {
      return i18n.t('queue:statistic tab.form.other settings.interval.interval options.1h');
    },
    value: '1h',
  },
  {
    get label() {
      return i18n.t('queue:statistic tab.form.other settings.interval.interval options.6h');
    },
    value: '6h',
  },
  {
    get label() {
      return i18n.t('queue:statistic tab.form.other settings.interval.interval options.12h');
    },
    value: '12h',
  },
  {
    get label() {
      return i18n.t('queue:statistic tab.form.other settings.interval.interval options.day');
    },
    value: '1d',
  },
];

export const defaultFormValues = {
  filters: [{ column: { value: 'stream_id' }, operator: { value: 'eq' } }],
  targets: [{ column: { value: 'event.people_count' }, aggregator: { value: 'max' } }],
  group_by: INTERVAL_OPTIONS[1],
  'period.gt': new Date(new Date().setHours(0, 0, 0, 0)),
  'period.lt': new Date(new Date().setDate(new Date().getDate() + 1)).setHours(0, 0, 0, 0),
};
